import React, { Component } from "react";
import Magnific from '../magnific.jsx';
import { postAskAQuestion } from '../../../apis/products';
import toast from '../../../components/toast';
import { addParamsToUrl } from '../../../utils';
import ReCAPTCHA from "react-google-recaptcha";

class AskAQuestion extends Component {
    constructor(props) {
        super(props);

        this.state = {
            name: '',
            email: '',
            confirmEmail: '',
            zipcode: '',
            city: '',
            state: '',
            question: '',
            show: false,
            isSending: false,
            errors: [],
            recaptchaError: '',
            passed: false
        };

        this.handleClick = this.handleClick.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.openBtn = React.createRef();

        this.recaptchaRef = React.createRef();
    }

    handleClick() {
        this.setState({
            show: true
        });
    }

    handleClose() {
        this.setState({
            show: false
        }, () => {
            this.openBtn.current.focus();
        });
    }

    handleFormSubmit(e) {
        e.preventDefault();

        const token = this.recaptchaRef.current.getValue();

        if (!this.state.isSending) {
            this.setState({
                isSending: true,
                errors: []
            });

            postAskAQuestion({
                nodeId: this.props.id,
                name: this.state.name,
                email: this.state.email,
                confirmEmail: this.state.confirmEmail,
                zipcode: this.state.zipcode,
                city: this.state.city,
                state: this.state.state,
                question: this.state.question,
                recaptchaToken: token
            })
                .then(json => {
                    this.setState({
                        isSending: false
                    });

                    if (json.success) {
                        toast.success('Your question has been submitted');
                        if (this.props.redirectTo) window.location = this.props.redirectTo;
                        else {
                            this.setState({
                                name: '',
                                email: '',
                                confirmEmail: '',
                                zipcode: '',
                                city: '',
                                state: '',
                                question: '',
                                show: false
                            });
                        }
                    }
                    else {
                        this.setState({
                            errors: json.errors
                        });
                    }
                })
                .catch(error => {
                    console.log(error);
                    this.setState({
                        isSending: false
                    });
                    toast.error('There was an issue sending your question. Please try again soon.');
                });
        }
    }

    handleChange(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    render() {
        let errors;
        const activator =
            <button className="btn" type="button" ref={this.openBtn} onClick={this.handleClick}>Ask a Question</button>;

        if (this.state.errors.length) {
            errors = <ul className="error-list">
                {this.state.errors.map((error) => (
                    <li>{error}</li>
                ))}
            </ul>;
        }

        return (
            <Magnific activator={activator} type="inline" show={this.state.show} onClose={this.handleClose}>
                <div className="card rounded padded">
                    <div className="card-title-content">
                        <h3 className="heading no-margin">Ask a Question</h3>
                    </div>
                    <div className="card-text-content">
                        <form ref={this.currentForm} action="#" method="post" onSubmit={this.handleFormSubmit}>
                            {errors}

                            <div className="form-group">
                                <label htmlFor="name">Your Name *</label>
                                <input className="form-control" type="text" id="name" name="name" placeholder="John Doe" required value={this.state.name} onChange={this.handleChange} />
                            </div>

                            <div className="form-group">
                                <label htmlFor="email">Your Email *</label>
                                <input className="form-control" type="email" id="email" name="email" placeholder="you@example.com" required value={this.state.email} onChange={this.handleChange} />
                            </div>

                            <div className="form-group">
                                <label htmlFor="confirmEmail">Confirm Your Email *</label>
                                <input className="form-control" type="email" id="confirmEmail" name="confirmEmail" required value={this.state.confirmEmail} onChange={this.handleChange} />
                            </div>

                            <div className="form-group">
                                <label htmlFor="zipcode">Zipcode *</label>
                                <input className="form-control" type="text" id="zipcode" name="zipcode" placeholder="12345" required value={this.state.zipcode} onChange={this.handleChange} />
                            </div>

                            <div className="form-group">
                                <label htmlFor="city">City *</label>
                                <input className="form-control" type="text" id="city" name="city" required value={this.state.city} onChange={this.handleChange} />
                            </div>

                            <div className="form-group">
                                <label htmlFor="state">State *</label>
                                <input className="form-control" type="text" id="state" name="state" required value={this.state.state} onChange={this.handleChange} />
                            </div>

                            <div className="form-group">
                                <label htmlFor="question">Your Question *</label>
                                <textarea className="form-control" id="question" name="question" placeholder="" rows="3" required value={this.state.question} onChange={this.handleChange}></textarea>
                            </div>
                            <ReCAPTCHA
                                sitekey="6LcOndkZAAAAAE7Hb968THW1Zyjt3MGCcF4R2NHQ"
                                ref={this.recaptchaRef}
                            />
                            <p className="error">{this.state.recaptchaError}</p>
                            <div className="form-actions">
                                <button className="btn" disabled={this.state.isSending}>Send</button>
                            </div>
                        </form>
                    </div>
                </div>
            </Magnific>
        );
    }
}

export default AskAQuestion;